import type { SxProps, Theme } from '@mui/material';

export const styles = {
    title: { fontWeight: 600 } as SxProps<Theme>,
    message: { color: 'grey.700' } as SxProps<Theme>,
    confirmBtn: (danger: boolean, theme: Theme): SxProps<Theme> => ({
        textTransform: 'uppercase',
        fontWeight: 600,
        color: 'white',
        backgroundColor: danger ? theme.palette.red.main : theme.palette.blue.main,
        '&:hover': {
            backgroundColor: danger
                ? theme.palette.red[800]
                : theme.palette.blue[800],
        },
    }),
};
